// Detectando Safari
if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
  // Código específico para Safari
  document.body.classList.add('safari-browser');
}
